import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DocumentListItemDTO } from "../../models/documentListItemsDTO";
import { DocumentListService } from "../../services/documentList.service";

@Component({
  selector: "app-rejected-document-preview",
  templateUrl: "./rejected-document-preview.component.html",
  styleUrls: ["./rejected-document-preview.component.scss"],
})
export class RejectedDocumentPreviewComponent {
  @Input() item: DocumentListItemDTO;
  @Output()
  closeRejectedDocumentPreview: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  backToPending: EventEmitter<DocumentListItemDTO> = new EventEmitter<DocumentListItemDTO>();
  @Output()
  uploadNew: EventEmitter<DocumentListItemDTO> = new EventEmitter<DocumentListItemDTO>();
  constructor(private readonly service: DocumentListService) {}

  onClose() {
    this.closeRejectedDocumentPreview.emit();
  }

  onBackToPending() {
    this.backToPending.emit(this.item);
  }

  onUploadNew() {
    this.uploadNew.emit(this.item);
  }
}
